import { AlertDialog } from '../AlertDialog'
import { useConfirm } from './useConfirm'

export const ConfirmModal: React.FC = () => {
	const {
		isOpen = false,
		proceed,
		cancel,
		title,
		message,
		okText,
		cancelText,
	} = useConfirm()

	const onCancel = () => cancel?.()
	const onConfirm = () => proceed?.()

	if (!isOpen) return null

	return (
		<AlertDialog
			open={isOpen}
			onOpenChange={(open) => {
				if (isOpen && !open) onCancel()
			}}
			title={title}
			description={message}
			confirm={okText}
			cancel={cancelText}
			onConfirm={onConfirm}
			onCancel={onCancel}
		/>
	)
}
